import React from 'react'

import { useTranslation } from 'react-i18next'
import { OrganizationTypes } from '../../interfaces/organization'
import { cn } from '../../utils/cn'

interface Props {
  status: OrganizationTypes['status']
  className?: string
}

const OrganizationStatus = ({ status, className }: Props) => {
  const { t } = useTranslation()
  let colorClass = ''

  switch (status) {
    case 'active':
      colorClass = 'bg-closedBg text-closedText'
      break
    default:
      colorClass = 'bg-inProgressBg text-inProgressText'
      break
  }
  return (
    <p
      className={cn(
        `${colorClass} w-[110px] mx-auto text-sm py-1 text-center rounded-lg font-medium`,
        className,
      )}
    >
      {t(status === 'active' ? 'active' : 'pending')}
    </p>
  )
}

export default OrganizationStatus
